import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../../services/api';

/**
 * Unsubscribe landing for the token in marketing email footers.
 * Route: /newsletter/unsubscribe?token=...
 *
 * Fires once on mount. Backend always returns success (it never confirms
 * or denies the existence of the email behind the token) — so the UI
 * messaging is identical whether the token was valid or stale.
 */
export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState(token ? 'submitting' : 'invalid');

  useEffect(() => {
    if (!token) return;
    api.post('/newsletter/unsubscribe', { token })
      .then(() => setStatus('done'))
      .catch(() => setStatus('done')); // backend hides existence either way
  }, [token]);

  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '80px 20px' }}>
      <div style={{ maxWidth: 480, textAlign: 'center' }}>
        {status === 'invalid' && (
          <>
            <p style={{ fontSize: 56, marginBottom: 18 }}>🤔</p>
            <h1 style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-0.02em', marginBottom: 12 }}>Missing unsubscribe token</h1>
            <p style={{ color: '#4A5568', fontSize: 15, lineHeight: 1.6, marginBottom: 28 }}>
              Use the unsubscribe link from your most recent PerkVora email — it carries the secure token.
            </p>
            <Link to="/" className="btn btn-primary btn-lg">Go home</Link>
          </>
        )}

        {status === 'submitting' && (
          <>
            <p style={{ fontSize: 56, marginBottom: 18 }}>⏳</p>
            <h1 style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-0.02em', marginBottom: 12 }}>Unsubscribing…</h1>
            <p style={{ color: '#4A5568', fontSize: 15, lineHeight: 1.6 }}>One moment.</p>
          </>
        )}

        {status === 'done' && (
          <>
            <p style={{ fontSize: 56, marginBottom: 18 }}>👋</p>
            <h1 style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-0.02em', marginBottom: 12 }}>You’re unsubscribed</h1>
            <p style={{ color: '#4A5568', fontSize: 15, lineHeight: 1.6, marginBottom: 28 }}>
              Sorry to see you go. You won’t receive any more marketing emails from PerkVora at this address.
              If this was a mistake, you can re-subscribe at the bottom of any page.
            </p>
            <Link to="/" className="btn btn-primary btn-lg">Back to PerkVora</Link>
          </>
        )}
      </div>
    </div>
  );
}
